"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.charterIndexPalette = void 0;
exports.charterIndexPalette = {
    brand: {
        light: '#e566a9',
        main: '#d40072',
        dark: '#7f0043',
        contrastText: '#fff',
    },
    dark: {
        main: '#3d3d3d',
        light: '#4f4f4f',
        contrastText: '#fff',
    },
};
//# sourceMappingURL=palette.js.map